import { Navigate, useParams } from "react-router-dom";
import usePageTitle from "@/hooks/usePageTitle";
import { getSectionOperationsFallbackPath } from "../_utils";
import { SectionGovernanceTable } from "./_components/SectionGovernanceTable";
import { useSectionOperationsAccess } from "./useSectionOperationsAccess";

export default function SectionOperationsGovernancePage() {
  const { sectionId } = useParams();
  const { ready, showCommittees, showSectionOfficeFacilityTabs, showNotifications, governanceEnabled } =
    useSectionOperationsAccess(sectionId);

  usePageTitle(`/sections/${sectionId}/operations/governance`, "Sections | Operations | Governance");

  if (!sectionId || !ready) {
    return null;
  }

  if (!governanceEnabled) {
    return (
      <Navigate
        to={getSectionOperationsFallbackPath(sectionId, {
          showCommittees,
          showSectionOfficeFacilityTabs,
          showNotifications
        })}
        replace
      />
    );
  }

  return (
    <div className="w-full" data-testid="section-operations-governance">
      <SectionGovernanceTable sectionId={sectionId} />
    </div>
  );
}
